import { Card, CircularProgress, Divider, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import axios from 'axios';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import DataNotFound from 'components/NoData/dataNotFound';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import noDataImage from "assets/images/illustrations/noData3.svg";
import React, { useEffect, useState } from 'react'
import MDButton from 'components/MDButton';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate, useParams } from 'react-router-dom';
import DeleteDialog from 'components/DeleteDialogBox/deleteDialog';
import { ToastContainer, toast } from 'react-toastify';
import VisibilityIcon from '@mui/icons-material/Visibility';

function SingleDefaultRole() {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const bearerToken = localStorage.getItem('token');
    const { id } = useParams();
    const [userRole, setUserRole] = useState();
    const [organizations, setOrganizations] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchUserRole = async () => {
        try {
            setIsLoading(true);
            const response = await axios.get(`${apiUrl}auth-service/default-role/${id}`,
                {
                    headers: { 'Authorization': `Bearer ${bearerToken}` }
                });
            if (response.data?.success) {
                setUserRole(response.data.data);
                console.log(response.data.data)
            } else throw new Error(response.data?.message || 'Error in fetching userRole');
        } catch (error) {
            console.error(error.response?.data?.message || error.message);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchUserRole();
    }, [bearerToken]);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6}>
                <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    pt={1}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                    display="flex"
                    justifyContent="space-between"
                >
                    <MDTypography variant="h6" color="white">
                        Default User Role
                    </MDTypography>
                </MDBox>
                {isLoading ? (
                    <MDBox p={3} display="flex" justifyContent="center">
                        <CircularProgress color="info" />
                    </MDBox>
                ) : userRole ? (
                    <MDBox position="relative" mb={5}>
                        <MDBox mt={5} mb={3}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={12} xl={12}>
                                    <Card sx={{ boxShadow: "none", p: 2 }}>
                                        {/* Role Details */}
                                        <MDBox mb={2}>
                                            <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                                                Role Details
                                            </MDTypography>
                                        </MDBox>
                                        {/* Role Name */}
                                        <MDBox mb={2}>
                                            <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                                                {userRole.name}
                                            </MDTypography>
                                        </MDBox>
                                        {/* Permissions List */}
                                        {userRole.defaultPermissions?.map((permission, index) => (
                                            <MDBox key={permission.id} mb={2}>
                                                <Grid container spacing={2} alignItems="flex-start">
                                                    {/* Permission Name */}
                                                    <Grid item xs={12} sm={4}>
                                                        <MDTypography variant="caption" fontWeight="bold" color="text.secondary" textTransform="uppercase">
                                                            Permission Name
                                                        </MDTypography>
                                                        <MDTypography variant="body2" color="text.primary" mt={1}>
                                                            {permission?.name || "-"}
                                                        </MDTypography>
                                                    </Grid>
                                                    {/* Permission Rules */}
                                                    <Grid item xs={12} sm={8}>
                                                        <MDTypography variant="caption" fontWeight="bold" color="text.secondary" textTransform="uppercase">
                                                            Rules
                                                        </MDTypography>
                                                        <MDBox mt={1}>
                                                            {permission.rules?.length ? (
                                                                <Grid container spacing={1}>
                                                                    {permission.rules.map((rule, idx) => (
                                                                        <Grid item key={idx} xs={6} sm={3}>
                                                                            <MDTypography
                                                                                variant="body2"
                                                                                color={rule.access ? "success.main" : "error.main"}
                                                                                sx={{
                                                                                    fontWeight: "medium",
                                                                                    textTransform: "capitalize",
                                                                                }}
                                                                            >
                                                                                {rule.name}
                                                                            </MDTypography>
                                                                        </Grid>
                                                                    ))}
                                                                </Grid>
                                                            ) : (
                                                                <MDTypography variant="body2" color="text.secondary">
                                                                    No rules available
                                                                </MDTypography>
                                                            )}
                                                        </MDBox>
                                                    </Grid>
                                                </Grid>
                                                {/* Divider for separation */}
                                                {index < userRole.defaultPermissions.length - 1 && <Divider sx={{ my: 2 }} />}
                                            </MDBox>
                                        ))}
                                    </Card>
                                </Grid>
                            </Grid>
                        </MDBox>
                    </MDBox>
                ) : (
                    <DataNotFound message="No User Role Available!" image={noDataImage} />
                )}

            </MDBox>
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </DashboardLayout>
    )
}
export default SingleDefaultRole